require('./bootstrap');

import './users'
import './wizard/wizard.js'
import './applicants'
import './settings'
import './notifications'
import './dashboard'
import './auditlog'
